import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const PaymentsAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		paymentreference: yup.string().required().label("Paymentreference"),
		bookingid: yup.string().required().label("Bookingid"),
		userid: yup.string().required().label("Userid"),
		amount: yup.number().required().label("Amount"),
		paymentmethod: yup.string().required().label("Paymentmethod"),
		paymentgateway: yup.string().nullable().label("Paymentgateway"),
		transactionid: yup.string().nullable().label("Transactionid"),
		gatewayresponse: yup.string().nullable().label("Gatewayresponse"),
		status: yup.string().required().label("Status"),
		paidat: yup.string().nullable().label("Paidat"),
		refundamount: yup.number().nullable().label("Refundamount"),
		refundreason: yup.string().nullable().label("Refundreason"),
		refundedat: yup.string().nullable().label("Refundedat"),
		createdat: yup.string().nullable().label("Createdat"),
		orderid: yup.string().nullable().label("Orderid")
	});
	
	//form default values
	const formDefaultValues = {
		paymentreference: '', 
		bookingid: '', 
		userid: '', 
		amount: '', 
		paymentmethod: '', 
		paymentgateway: '', 
		transactionid: '', 
		gatewayresponse: '', 
		status: '', 
		paidat: new Date(), 
		refundamount: '', 
		refundreason: '', 
		refundedat: new Date(), 
		createdat: "(getdate())", 
		orderid: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/payments`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="PaymentsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Payment"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentreference *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentreference"  onChange={formik.handleChange}  value={formik.values.paymentreference}   label="Paymentreference" type="text" placeholder="Enter Paymentreference"        className={inputClassName(formik?.errors?.paymentreference)} />
                                                <ErrorMessage name="paymentreference" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Bookingid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/bookingid_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="bookingid"     optionLabel="label" optionValue="value" value={formik.values.bookingid} onChange={formik.handleChange} options={response} label="Bookingid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.bookingid)}   />
                                                    <ErrorMessage name="bookingid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="userid"     optionLabel="label" optionValue="value" value={formik.values.userid} onChange={formik.handleChange} options={response} label="Userid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.userid)}   />
                                                    <ErrorMessage name="userid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Amount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amount"  onChange={formik.handleChange}  value={formik.values.amount}   label="Amount" type="number" placeholder="Enter Amount"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.amount)} />
                                                <ErrorMessage name="amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentmethod *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentmethod"  onChange={formik.handleChange}  value={formik.values.paymentmethod}   label="Paymentmethod" type="text" placeholder="Enter Paymentmethod"        className={inputClassName(formik?.errors?.paymentmethod)} />
                                                <ErrorMessage name="paymentmethod" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentgateway 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentgateway"  onChange={formik.handleChange}  value={formik.values.paymentgateway}   label="Paymentgateway" type="text" placeholder="Enter Paymentgateway"        className={inputClassName(formik?.errors?.paymentgateway)} />
                                                <ErrorMessage name="paymentgateway" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Transactionid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="transactionid"  onChange={formik.handleChange}  value={formik.values.transactionid}   label="Transactionid" type="text" placeholder="Enter Transactionid"        className={inputClassName(formik?.errors?.transactionid)} />
                                                <ErrorMessage name="transactionid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Gatewayresponse 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="gatewayresponse"  onChange={formik.handleChange}  value={formik.values.gatewayresponse}   label="Gatewayresponse" type="text" placeholder="Enter Gatewayresponse"        className={inputClassName(formik?.errors?.gatewayresponse)} />
                                                <ErrorMessage name="gatewayresponse" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Status *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="status"  onChange={formik.handleChange}  value={formik.values.status}   label="Status" type="text" placeholder="Enter Status"        className={inputClassName(formik?.errors?.status)} />
                                                <ErrorMessage name="status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paidat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="paidat" value={formik.values.paidat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.paidat)}        />
                                                <ErrorMessage name="paidat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Refundamount 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="refundamount"  onChange={formik.handleChange}  value={formik.values.refundamount}   label="Refundamount" type="number" placeholder="Enter Refundamount"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.refundamount)} />
                                                <ErrorMessage name="refundamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Refundreason 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="refundreason"  onChange={formik.handleChange}  value={formik.values.refundreason}   label="Refundreason" type="text" placeholder="Enter Refundreason"        className={inputClassName(formik?.errors?.refundreason)} />
                                                <ErrorMessage name="refundreason" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Refundedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="refundedat" value={formik.values.refundedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.refundedat)}        />
                                                <ErrorMessage name="refundedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Orderid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="orderid"  onChange={formik.handleChange}  value={formik.values.orderid}   label="Orderid" type="text" placeholder="Enter Orderid"        className={inputClassName(formik?.errors?.orderid)} />
                                                <ErrorMessage name="orderid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
PaymentsAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'payments',
	apiPath: 'payments/add',
	routeName: 'paymentsadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default PaymentsAddPage;
